import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const MapSection = () => {
  const { language } = useLanguage();
  const t = translations[language].ggs;
  const tNews = translations[language].newsroom;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-3xl font-bold text-gray-900 mb-12 border-l-4 border-red-600 pl-4">
          {t.title} <span className="text-gray-400 font-light">– {t.subtitle.split('–')[1] || t.subtitle}</span>
        </h2>

        <div className="flex flex-col lg:flex-row gap-12 items-start">
          {/* Left: Content */}
          <div className="flex-1 space-y-6 text-gray-600 leading-relaxed text-lg text-justify">
            <p>
              {t.p1}
            </p>
            <p>
              {t.p2}
            </p>

            <div className="pt-4">
              <Link to="/about/ggs" className="inline-flex items-center text-red-600 font-bold hover:text-red-700 transition-colors group">
                {tNews.readMore}
                <ArrowRight className={`ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform ${language === 'ar' ? 'rotate-180 group-hover:-translate-x-1' : ''}`} />
              </Link>
            </div>
          </div>

          {/* Right: Image */}
          <div className="flex-1 w-full relative group">
            <div className="absolute inset-0 bg-red-600 rounded-2xl transform rotate-3 opacity-0 group-hover:opacity-10 transition-opacity duration-500"></div>
            <img
              src="/assets/car.jpg"
              alt="Gulf Great Sands Showroom"
              className="w-full rounded-2xl shadow-xl relative z-10"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;